import { useState } from 'react'

import { useStyles } from './file-upload-button.style'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload } from '@fortawesome/pro-solid-svg-icons'

export const FileUploadButton = function ({ className = '', label = 'Choose a file...', onChange = () => {}, accept }) {
  const classes = useStyles()
  const [fileName, setFileName] = useState()

  function handleChange (event) {
    if (event.target && event.target.files && event.target.files.length > 0) {
      setFileName(event.target.files[0].name)
    }
    onChange(event)
    event.target.value = null
  }

  return (
    <label>
      <div className={`${classes.label} ${className}`}>
        <FontAwesomeIcon className={classes.uploadIcon} size={'sm'} icon={faUpload}/>
        <span className={classes.text}>{fileName || label}</span>
      </div>
      <input className={classes.input} type="file" onChange={handleChange} accept={accept} data-qa="file-upload-button"/>
    </label>)
}
